import { IbcustBaseUrl } from '@ibkr/clientportal.common/src/js/ibcustBaseUrl.js'
import { handleResponse } from './default'

const base = IbcustBaseUrl.get();
const httpContentType = 'application/json; charset=utf-8';

const apiGet = path => fetch(path, {
        credentials: 'include'
    })
    .then(handleResponse);

const apiPost = (path,body) => fetch(path, {
        method: 'post',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
            'Content-Type': httpContentType
        }
    })
    .then(handleResponse);


function getEmail() {
    return apiGet(base + '/user/email');
}
/*
 * This end-point may return iserver accounts or accounts from the portfolio router.
 * It depends how the router is configured
 */
function getUser() {
    return apiGet(base + '/one/user');
}

function getMarketDataSubscriptions() {
    return apiGet(base + '/marketdata/subscriptions');
}

function getEntityInfo() {
    return apiGet(base + '/entity/info');
}

function saveEmail(data) {
    return apiPost(base + '/user/email', data);
}

function sendEmail(data) {
    return apiPost(base + '/user/sendemail', data);
}

function setUser(username) {
    return apiGet(base + '/inject?user=' + username);
}

function logout() {
    return apiPost(base + '/logout');
}

function getAccountStatus(data) {
    return apiPost(base + '/tasks/edd/status/', data);
}

export default {
    getEmail,
    getEntityInfo,
    getMarketDataSubscriptions,
    getUser,
    saveEmail,
    sendEmail,
    setUser,
    logout,
    getAccountStatus
}
